import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { useAuth } from "../../context/AuthContext";
import Header from "../../components/Header/Header";
import "./signup.css";

function SelectPersona() {
  const { user, refreshProfile } = useAuth();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  if (!user) return null;

  const handleSelect = async (persona) => {
    try {
      setSaving(true);
      setError("");

      await setDoc(
        doc(db, "users", user.uid),
        {
          email: user.email,
          persona, // "founder" | "evaluator"
          createdAt: serverTimestamp(),
        },
        { merge: true }
      );

      await refreshProfile();

      if (persona === "founder") {
        navigate("/complete-profile", { replace: true });
      } else {
        navigate("/evaluator-onboarding", { replace: true });
      }
    } catch (err) {
      console.error(err);
      setError("Failed to save selection. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Header />

      <div className="signup-container">
        <div className="step-card">
          <h2>How will you use Prufyy?</h2>
          <p>
            This helps us set up the right experience for you. You can’t change
            this later.
          </p>

          {error && <div className="signup-error">{error}</div>}

          <div style={{ display: "grid", gap: 16 }}>
            <button
              className="primary-button"
              onClick={() => handleSelect("founder")}
              disabled={saving}
            >
              I’m a Founder
            </button>

            <button
              className="secondary-button"
              onClick={() => handleSelect("evaluator")}
              disabled={saving}
            >
              I evaluate startups (Investor / Accelerator / Incubator)
            </button>
          </div>

          {saving && (
            <p style={{ marginTop: 20, fontSize: 14, textAlign: "center" }}>
              Setting things up…
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default SelectPersona;
